import { render, staticRenderFns } from "./NC-Abonnements.vue?vue&type=template&id=dfc8c8be&scoped=true"
import script from "./NC-Abonnements.vue?vue&type=script&lang=js"
export * from "./NC-Abonnements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc8c8be",
  null
  
)

export default component.exports